<template>
  <ImageUploaderModule :moduleId="moduleId" type="logos" />
</template>

<script>
import ImageUploaderModule from './ImageUploaderModule.vue';
export default {
  name: 'OnstageImages',
  components: { ImageUploaderModule },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  }
};
</script>
